"use client";

import Link from "next/link";
import Image from "next/image";
import { Button } from "@/app/components/ui/button";
import { ArrowLeft, Home } from "lucide-react";
import { useRouter } from "next/navigation";

export default function NotFound() {
  const router = useRouter();

  return (
    <div className="min-h-screen flex items-center justify-center px-4 bg-gray-50">
      <div className="max-w-md w-full bg-white rounded-lg shadow-md p-8 text-center">
        <div className="relative w-52 h-52 mx-auto mb-6">
          <Image
            src="/404.svg"
            alt="404 Illustration"
            fill
            className="object-contain"
            onError={(e) => {
              // Fallback if the SVG doesn't load
              e.currentTarget.style.display = "none";
            }}
          />
          {/* Fallback content if image fails to load */}
          <div className="absolute inset-0 flex items-center justify-center text-8xl font-bold text-yellow-500 opacity-20">
            404
          </div>
        </div>

        <h1 className="text-3xl md:text-4xl font-bold mb-4">Sayfa Bulunamadı</h1>
        
        <p className="text-gray-600 mb-8">
          Aradığınız sayfa mevcut değil veya taşınmış olabilir. 
          Lütfen ana sayfaya dönün veya farklı bir sayfa deneyin.
        </p>

        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <Button 
            variant="outline" 
            className="flex items-center gap-2"
            onClick={() => router.back()}
          >
            <ArrowLeft size={16} />
            Geri Dön
          </Button>
          
          <Button 
            className="flex items-center gap-2 bg-yellow-500 hover:bg-yellow-600"
          >
            <Link href="/" className="flex items-center gap-2">
              <Home size={16} />
              Ana Sayfa
            </Link>
          </Button>
        </div>
      </div>
    </div>
  );
} 